import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-white px-5 py-20 sm:px-8" data-id="element-47" data-mp="1gd7h4a4s9d6j">
      <div className="mx-auto w-full max-w-2xl" data-id="element-48" data-mp="1gaurdass9yix">
        <Reveal data-id="element-49" data-mp="2dzemhm8wv9jy">
          <h2 className="text-center font-display text-3xl font-extrabold tracking-tight text-navy sm:text-4xl" data-id="element-50" data-mp="2dzxti7x0wdj7">
            Frequently Asked <span className="text-brand-strong" data-id="element-51" data-mp="28ziivo44lk4x">Questions</span>
          </h2>
        </Reveal>

        <Reveal delay={0.06} data-id="element-52" data-mp="244cv0jr5xve7">
          <div className="mt-12 overflow-hidden rounded-card border border-navy/10" data-id="element-53" data-mp="1z3owld0luc9y">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return <div key={faq.question} className={index > 0 ? 'border-t border-navy/10' : ''} data-id="element-54" data-mp="nniho17q1l71" data-mpi={index}>
                  <h3 data-id="element-55" data-mp="pipktwgzw93t">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 bg-white px-5 py-5 text-left transition-colors duration-150 ease-out hover:bg-tint focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand/40" data-id="element-56" data-mp="pg3c3tidbnk0">
                      <span className="text-md font-bold text-navy" data-id="element-57" data-mp="bjpy4ud1m4aa">{faq.question}</span>
                      {isOpen ? <MinusIcon className="h-4 w-4 shrink-0 text-brand-deep" aria-hidden="true" data-id="element-58" data-mp="3swk1vcipj7t7" /> : <PlusIcon className="h-4 w-4 shrink-0 text-brand-deep" aria-hidden="true" data-id="element-59" data-mp="3k0cdzp4072zg" />}
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-60" data-mp="1pp34oa7d5ec1">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden bg-tint" data-id="element-61" data-mp="1kq9scl3tbtdg">
                        <p className="px-5 pb-5 pt-4 text-sm leading-relaxed text-navy/75" data-id="element-62" data-mp="23h9cn90d4f0e">
                          {faq.answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </Reveal>
      </div>
    </section>;
}